<script>
    import {createEventDispatcher} from "svelte";

    const dispatch = createEventDispatcher();

    export let display_tag = '';
    export let show_delete_button = false;

    const onItemClicked = id => {
        dispatch('tagClicked', {id:id});
    }
    const onDeleteClicked = id => {
        dispatch('deleteClicked', {id:id});
    };
</script>

<span class="inline-flex items-center rounded-full bg-{display_tag.bg_colour === 'default' ? 'indigo' : `${display_tag.bg_colour}`}-100 py-0.5 pl-2.5 pr-1 mb-2 mr-1 text-sm font-medium text-{display_tag.text_colour === 'default' ? 'indigo' : `${display_tag.text_colour}`}-700">
    {display_tag.name.split(':').length === 1 ? display_tag.name.split(':')[0] : display_tag.name.split(':')[1]}
    {#if show_delete_button}
    <button type="button" on:click={() => onDeleteClicked(display_tag.id)} class="ml-0.5 inline-flex h-4 w-4 flex-shrink-0 items-center justify-center rounded-full text-{display_tag.text_colour === 'default' ? 'indigo' : `${display_tag.text_colour}`}-400 hover:bg-{display_tag.bg_colour === 'default' ? 'indigo' : `${display_tag.bg_colour}`}-200 hover:text-{display_tag.text_colour === 'default' ? 'indigo' : `${display_tag.text_colour}`}-500 focus:bg-{display_tag.bg_colour === 'default' ? 'indigo' : `${display_tag.bg_colour}`}-500 focus:text-white focus:outline-none">
        <span class="sr-only">Remove tag</span>
        <svg class="h-2 w-2" stroke="currentColor" fill="none" viewBox="0 0 8 8">
            <path stroke-linecap="round" stroke-width="1.5" d="M1 1l6 6m0-6L1 7" />
        </svg>
    </button>
    {:else}
        <span class="inline-flex block ml-0.5 h-4 w-1"></span>
    {/if}
</span>
<!-- List used colours here because the script can't extract runtime concatenated strings..
bg-indigo-100 bg-indigo-200 bg-indigo-500 text-indigo-400 text-indigo-500 text-indigo-700
bg-sky-100 bg-sky-200 bg-sky-500 text-sky-400 text-sky-500 text-sky-700
bg-rose-100 bg-rose-200 bg-rose-500 text-rose-400 text-rose-500 text-rose-700
bg-blue-100 bg-blue-200 bg-blue-500 text-blue-400 text-blue-500 text-blue-700
bg-pink-100 bg-pink-200 bg-pink-500 text-pink-400 text-pink-500 text-pink-700
bg-lime-100 bg-lime-200 bg-lime-500 text-lime-400 text-lime-500 text-lime-700
bg-green-100 bg-green-200 bg-green-500 text-green-400 text-green-500 text-green-700
bg-stone-100 bg-stone-200 bg-stone-500 text-stone-400 text-stone-500 text-stone-700
-->

<style></style>